import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DrJeffLandingPage from './pages/DrJeffLandingPage';
import FeedbackPage from './pages/FeedbackPage';
import '@questlabs/react-sdk/dist/style.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DrJeffLandingPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
      </Routes>
    </Router>
  );
}

export default App;